export default __webpack_public_path__ + "static/media/Prabu.d88bdab1.jpg";